import React from "react";
import ProjectListLayer from "../components/ProjectListLayer";
import Breadcrumb from "../components/Breadcrumb";

const ProjectListPage = () => {
  return (
  
    <>
    
    <Breadcrumb title={"Project List"}/>
  
  <ProjectListLayer />
    
    </>

);
};

export default ProjectListPage;
